import {connect} from "react-redux";
import React, {useEffect, useMemo, useRef, useState} from "react";
import dayjs from "dayjs";
import * as formatter from "../../../../config/formatter";
import * as o2Api from "../../../../api/api";
import {Loading} from "../../../../components/common";
import {CAlert, CButton, CCol, CForm, CFormSelect, CInputGroup, CInputGroupText} from "@coreui/react";
import StoreListWhere from "../../where/StoreListWhere";
import {DatePicker} from "antd";
import locale from "antd/es/date-picker/locale/ko_KR";
import {AgGridReact} from "ag-grid-react";
import StoreCornerListWhere from "../../where/StoreCornerListWhere";

const ManualSaleRegister = (props) => {
	const gridRef = useRef();
	const containerStyle = useMemo(() => ({width: "100%", height: "100%"}), []);
	const [pos, setPos] = useState([{deviceId: "전체"}]);
	const [rowData, setRowData] = useState([]);
	const [error, setError] = useState({
		visible: false,
		message: ""
	});
	const [searchForm, setSearchForm] = useState({
		saleDt: dayjs().add(-1, "d")
	});

	const defaultColDef = {
		width: 100,
		resizable: true,
		sortable: true,
		filter: false,
		autoHeaderHeight: true
	};

	const [columnDefs] = useState([
		{field: "posCd", headerName: "POS", cellClass: "static-cell"},
		{field: "cmpCd", headerName: "회원사코드", hide: true},
		{field: "brandCd", headerName: "브랜드코드", hide: true},
		{field: "storeCd", headerName: "매장코드", hide: true},
		{field: "billNo", headerName: "영수번호", cellClass: "static-cell"},
		{field: "tradeTypeNm", headerName: "구분", cellClass: "static-cell"},
		{field: "saleQty", headerName: "품목수", valueFormatter: formatter.currencyFormatter, cellClass: "number-cell"},
		{field: "saleAmt", headerName: "총매출액", valueFormatter: formatter.currencyFormatter, cellClass: "number-cell"},
		{field: "dcAmt", headerName: "할인액", valueFormatter: formatter.currencyFormatter, cellClass: "number-cell"},
		{field: "payAmt", headerName: "실매출액", valueFormatter: formatter.currencyFormatter, cellClass: "number-cell"},
		{field: "netAmt", headerName: "가액", valueFormatter: formatter.currencyFormatter, cellClass: "number-cell"},
		{field: "payAmtVat", headerName: "부가세", valueFormatter: formatter.currencyFormatter, cellClass: "number-cell"},
		{
			field: "totalPayAmt",
			headerName: "결제합계", valueGetter: (e) => {
				return e.data.cashAmt + e.data.cardAmt;
			}, minWidth: 80, valueFormatter: formatter.currencyFormatter, cellClass: "number-cell"
		},
		{field: "cashAmt", headerName: "현금결제", valueFormatter: formatter.currencyFormatter, cellClass: "number-cell"},
		{field: "cardAmt", headerName: "카드결제", valueFormatter: formatter.currencyFormatter, cellClass: "number-cell"},
	]);

	useEffect(() => {
		if (props.selected.storeCd.length > 0) {
			getStoreDevice();
		}
	}, [props.selected.storeCd]);

	const handleSelect = (code, value) => {
		if (value === "C") {
			setSearchForm((state) => ({
				...state,
				cmpCd: code, brandCd: "", storeCd: "", cornerCd: ""
			}));
		} else if (value === "B") {
			setSearchForm((state) => ({
				...state,
				cmpCd: state.cmpCd, brandCd: code, storeCd: "", cornerCd: ""
			}));
		} else if (value === "S") {
			setSearchForm((state) => ({
				...state,
				cmpCd: state.cmpCd, brandCd: state.brandCd, storeCd: code, cornerCd: ""
			}));
		} else if (value === "O") {
			setSearchForm((state) => ({
				...state,
				cmpCd: state.cmpCd, brandCd: state.brandCd, storeCd: state.storeCd, cornerCd: code
			}));
		}
	};

	const getStoreDevice = () => {
		const {cmpCd, brandCd, storeCd} = props.selected;
		const params = {
			cmpCd: cmpCd,
			brandCd: brandCd,
			storeCd: storeCd,
			useYn: "Y"
		};
		props.setLoading(true);
		o2Api.getStoreDevice(params).then((result) => {
			const {responseBody, responseCode, responseMessage} = result.data;
			if (responseCode === "200") {
				// 성공
				setPos([{deviceId: ""}]);
				setPos((state) => state.concat(responseBody));

				props.setLoading(false);
			}
		});
	};

	const search = () => {
		setError({visible: false, message: ""});
		const {cmpCd, brandCd, storeCd, deviceId} = searchForm;
		console.log(">>> search :: ", cmpCd, brandCd, storeCd, deviceId);

		if (brandCd === undefined || brandCd.length === 0) {
			setError({
				visible: true,
				message: "조회시 휴게소는 반드시 선택하셔야 합니다."
			});
			return;
		}

		if (storeCd === undefined || storeCd.length === 0) {
			setError({
				visible: true,
				message: "조회시 매장은 반드시 선택하셔야 합니다."
			});
			return;
		}

		if (deviceId.length === 0 || deviceId === "전체") {
			setError({
				visible: true,
				message: "조회시 POS 번호는 반드시 선택하셔야 합니다."
			});
			return;
		}

		const params = {
			cmpCd: cmpCd,
			brandCd: brandCd,
			storeCd: storeCd,
			posCd: searchForm.deviceId === "전체" ? "" : searchForm.deviceId,
			saleDt: searchForm.saleDt.format("YYYYMMDD")
		};

		props.setLoading(true);
		o2Api.getCurrentDay(params).then((result) => {
			const {responseBody, responseCode, responseMessage} = result.data;
			console.log("result : ", responseBody);

			if (responseCode === "200") {
				// 성공
				setRowData(responseBody);
				props.setLoading(false);

				createFooterData(responseBody);
			}
		});
	};

	const create = () => {
		if (searchForm.deviceId.length === 0) {
			alert("POS번호를 선택해주세요.");
			return;
		}

		const paramCmpCd = "cmpCd=" + searchForm.cmpCd;
		const paramBrandCd = "brandCd=" + searchForm.brandCd;
		const paramStoreCd = "storeCd=" + searchForm.storeCd;
		const paramSaleDt = "saleDt=" + searchForm.saleDt.format("YYYYMMDD");
		const paramPosCd = "posCd=" + searchForm.deviceId;
		const params = paramSaleDt + "&" + paramCmpCd + "&" + paramBrandCd + "&" + paramStoreCd + "&" + paramPosCd;
		window.open("/#/sale/manual/reg?" + params, "_detail", "width=1024, height=600");
	}

	const sum = (values, col) => {
		let sum = 0;
		values.forEach((value) => {
			sum += value[col]
		})
		return sum;
	}

	const createFooterData = (data) => {
		const api = gridRef.current.api;
		const result = [];
		result.push({
			posCd: "합계",
			saleTime: null,
			saleQty: sum(data, 'saleQty'),
			saleAmt: sum(data, 'saleAmt'),
			dcAmt: sum(data, 'dcAmt'),
			payAmt: sum(data, 'payAmt'),
			netAmt: sum(data, 'netAmt'),
			payAmtVat: sum(data, 'payAmtVat'),
			totalPayAmt: sum(data, 'totalPayAmt'),
			cashAmt: sum(data, 'cashAmt'),
			cardAmt: sum(data, 'cardAmt')

		});
		api.setPinnedBottomRowData(result);
	};

	const [totalRowData] = useState([
		{posCd: "합계", saleTime: null, saleQty: 0, saleAmt: 0, dcAmt: 0, payAmt: 0, netAmt: 0, vatAmt: 0, bagPrice: 0}
	])

	return (
		<div style={containerStyle}>
			{error.visible ? <CAlert color="danger" dismissible={true}>{error.message}</CAlert> : null}
			<div className="d-md-flex justify-content-between p-1" style={{marginBottom: 10}}>
				<h5>매출수기등록</h5>
			</div>
			<StoreCornerListWhere type={"S"} account={props.account} selected={searchForm}
								  onSelect={(c, v) => handleSelect(c, v)}/>
			<div className={"row row-cols-lg-auto g-1 m-0 align-items-center"}>
                <CCol xs={12} md={6}>
					<CInputGroup size={"sm"}>
						<CInputGroupText style={{width: 80}}>조회일자</CInputGroupText>
						<CInputGroupText style={{background: "white", height: 35}}>
							<DatePicker bordered={false}
										separator={"~"}
										placeholder={""}
										locale={locale}
										value={searchForm.saleDt}
										onChange={(dayjs, dateString) => {
											setSearchForm((state) => ({
												...state, saleDt: dayjs
											}));
										}}/>
						</CInputGroupText>
					</CInputGroup>
				</CCol>
                <CCol xs={12} md={6}>
					<CInputGroup size={"sm"}>
						<CInputGroupText style={{width: 80}}>포스번호</CInputGroupText>
						<CFormSelect value={searchForm.deviceId}
									 onChange={(e) => {
										 setSearchForm((state) => ({
											 ...state,
											 deviceId: e.target.value
										 }));
									 }}
						>
							{pos.map((p, index) => {
								return (
									<option key={index} value={p.deviceId}>{p.deviceId}</option>
								);
							})}
						</CFormSelect>
					</CInputGroup>
				</CCol>
                <div className={"d-grid d-lg-flex gap-1"}>
					<CButton style={{minWidth: 50, height: 35}} size={"sm"} color={"primary"} onClick={search}>조회</CButton>
					<CButton style={{minWidth: 50, height: 35}} size={"sm"} color={"primary"} onClick={create}>신규</CButton>
				</div>
			</div>

			<div style={{height: 10}}/>
			<h6><span style={{color: "red"}}>*</span>마감 데이터가 생성된 매장/일자만 등록이 가능합니다.</h6>
			<h6><span style={{color: "red"}}>*</span>수기매출 집계처리에 약 1분의 시간이 소요됩니다. 바로 조회가 되지 않을 경우 시간을 두고 조회해 주세요.</h6>
			<div>
				<div className="ag-theme-alpine" style={{width: "100%", height: 500, marginTop: 10}}>
					<AgGridReact
						ref={gridRef}
						rowSelection={"single"}
						headerHeight={30}
						rowHeight={30}
						rowData={rowData}
						animateRows={true}
                        enableRangeSelection={true}
                        enableCellTextSelection={true}
                        suppressClipboardPaste={true}
                        localeText={{noRowsToShow: "조회 결과가 없습니다."}}
						pinnedBottomRowData={totalRowData}
						defaultColDef={defaultColDef}
						columnDefs={columnDefs}>
					</AgGridReact>
				</div>
			</div>
		</div>
	);
}

const mapStateToProps = (state) => {
	const {account, store, selected} = state;
	return {
		account, store, selected
	};
};

export default connect(mapStateToProps, null)(ManualSaleRegister);
